/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const BotNAcciN = ({ className, text = "Botón", onClick}) => {
  return (
    <div className={`bot-n-acci-n ${className}`} onClick = {onClick}>
      <div className="bot-n">{text}</div>
    </div>
  );
};

BotNAcciN.propTypes = {
  text: PropTypes.string,
};
